import { createFileRoute, Outlet } from "@tanstack/react-router";

import ClientCreationWarning from "@/components/client/client-creation-warning";
import InactiveNotice from "@/components/client/inactive-notice";
import GradCapLoader from "@/components/ui/grad-cap-loader";
import { ProtectedRoute } from "@/services/auth/auth-context";
import { useClientAccessGuard } from "@/services/client/use-client-access-guard";

export const Route = createFileRoute("/clientdashboard/_layout")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ProtectedRoute fallbackPath="/login?from=clientdashboard">
      <ClientDashboardGuard />
    </ProtectedRoute>
  );
}

/**
 * Guard component that handles client access checks.
 * Renders appropriate UI based on client status, or the Outlet when ready.
 */
function ClientDashboardGuard() {
  // autoRedirect: true means the hook's useEffect will handle navigation
  // for "needs-onboarding" -> /clientdashboard/onboard
  // for "needs-engagement" -> /clientdashboard/engagement_agreement
  const { status } = useClientAccessGuard({ autoRedirect: true });

  switch (status) {
    case "loading":
      return <GradCapLoader />;

    case "staff-warning":
      return <ClientCreationWarning />;

    case "inactive":
      return <InactiveNotice />;

    case "needs-onboarding":
    case "needs-engagement":
      // Hook's useEffect handles the redirect, show loader while redirecting
      return <GradCapLoader />;

    case "ready":
      return <Outlet />;

    default:
      return <Outlet />;
  }
}
